import React, { useState, useEffect, useTransition } from 'react';
// import '../src/commonCss/loader.css';
import '../src/commonCss/Loader.css';

// import '../commonCss/Loader.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Blog from './Pages/Blog';
import HomePage from './Pages/HomePage';
import ContactUs from './Pages/ContactUs';
import CorporateTravelManagement from './Pages/CorporateTravelManagement';
import TravelArrangements from './Pages/TravelArrangements';
import Bliesure from './Pages/Bliesure';
import Consultation from './Pages/Consultation';
import Meetings from './Pages/Meetings';
import GlobalServices from './Pages/Globalservices';
import OurStory from './Pages/OurStory';
import MissionAndVission from './Pages/MissionAndVission';
import Restrictions from './Pages/Restrictions';
import OurLocation from './Pages/OurLocation';
import EventWebinar from './Pages/EventWebinar';
import TechPlatform from './Pages/TechPlatform';
import Awards from './Pages/Awards';
import CaseStudies from './Pages/CaseStudies';
import BlogInner from './Pages/BlogInner';
import StrategicManagement from './Pages/StrategicManagement';
import Entertainment from './Pages/Entertainment';
import SportsTravel from './Pages/SportsTravel';
import UniversityTravel from './Pages/UniversityTravel';
import GovernmentTravel from './Pages/GovernmentTravel';
import CorporateTravelers from './Pages/CorporateTravelers';
import TermsAndCondition from './Pages/TermsAndCondition';
import Partners from './Pages/Partners';
import BlogData from './Componentsss/BlogInnerPage/BlogData/BlogData';
import CarRentalService from './Pages/CarRentalServices';
import MIICESolution from './Pages/MIICESolution';
import Tourism from './Pages/Tourism';
import BusinessTravel from './Pages/BusinessTravel';
import { ImageStoreProvider } from "../src/store/ImageStore/ImageStore";

// Import loader image
// import loaderGif from './assets/BBG-loader.gif'; 

const AppRouter = () => {
  const [loading, setLoading] = useState(true);
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    // Check if user is visiting for the first time
    if (!sessionStorage.getItem("visited")) {
      sessionStorage.setItem("visited", "true"); // Mark as visited
      setTimeout(() => setLoading(false), 3000); // Show loader for 3 seconds
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    startTransition(() => {
      // Simulating network delay (you can replace this with actual route change handling)
      setTimeout(() => setLoading(false), 3000);
    });
  }, []);

  return (
    <>
      {(loading || isPending) ? (
        <div className="loader-container">
          <img src="/BBTloader.gif" alt="Loading..." className="loader-gif" />
        </div>
      ) : (
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/corporate-travel" element={<CorporateTravelManagement />} />
            <Route path="/travel-arrangements" element={<TravelArrangements />} />
            <Route path="/bliesure" element={<Bliesure />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/meeting" element={<Meetings />} />
            <Route path="/global-solution" element={<GlobalServices />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/mission-vision" element={<MissionAndVission />} />
            {/* Prop Passing */}
            <Route path="/restrictions" element={<Restrictions />} />
            <Route path="/our-location" element={<OurLocation />} />
            <Route path="/event-webinar" element={<EventWebinar />} />
            <Route path="/tech-platform" element={<TechPlatform />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/blog/:Slug" element={<BlogData />} /> 
            {/* No Prelaod Image done here*/}
            <Route path="/business-travel" element={<BusinessTravel />} />
            <Route path="/strategic" element={<StrategicManagement />} />
            <Route path="/entertainment" element={<Entertainment />} />
            <Route path="/sports-travel" element={<SportsTravel />} />
            <Route path="/university" element={<UniversityTravel />} />
            <Route path="/government" element={<GovernmentTravel />} />
            <Route path="/corporate" element={<CorporateTravelers />} />
            <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/car-rental-services" element={<CarRentalService />} />
            <Route path="/MICESolutions" element={<MIICESolution />} />
            <Route path="/tourism" element={<Tourism />} />
          </Routes>
        </Router>
      )}
    </>
  );
};

export default AppRouter;
